<div class="card-container">
  <div class="card-header">
    <div class="section-name">
      <img src="assets/icons/perfil-detalle-consulta.svg" alt="" />
      <span class="contact-name texto-info">{{ data.nombrePaciente }}</span>
    </div>
    <div class="section-close">
      <button
        (click)="dialogRef.close()"
        tabindex="-1"
        mat-icon-button
        matTooltip="Cerrar"
        aria-label="icon-button close"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="card-row" style="gap: 40px">
      <div style="display: flex; gap: 12px">
        <img
          src="assets/icons/calendar-info-consulta.svg"
          style="display: table-cell"
          alt="house"
        />
        <span class="texto-light">{{ data.fechaAtencion | date : 'dd/MM/yyyy' }}</span>
      </div>
      <div style="display: flex; gap: 12px">
        <img src="assets/icons/clock-info-consulta.svg" style="display: table-cell" alt="house" />
        <span class="texto-light">{{ data.horaAtencion }}</span>
      </div>
    </div>

    <div class="card-row texto-info" style="gap: 12px">
      <img src="assets/icons/tel-info-consulta.svg" style="display: table-cell" alt="house" />
      <span class="texto-light">{{ data.telefonoPaciente }}</span>
    </div>

    <div
      class="card-row chip-tipo-consulta"
      [ngClass]="{
        presencial: tipoAtencion === TipoAtencion.PRESENCIAL,
        telemedicina: tipoAtencion === TipoAtencion.TELEMEDICINA,
        domiciliaria: tipoAtencion === TipoAtencion.DOMICILIARIA
      }"
    >
      <div>
        @switch ( tipoAtencion ) { @case ( TipoAtencion.PRESENCIAL ) {
        <img src="assets/icons/hospital.svg" style="display: table-cell" alt="hospital" />
        } @case ( TipoAtencion.TELEMEDICINA ) {
        <img src="assets/icons/telemedicina.svg" style="display: table-cell" alt="telemedicina" />
        } @case ( TipoAtencion.DOMICILIARIA ) {
        <img src="assets/icons/house.svg" style="display: table-cell" alt="house" />
        } }
      </div>
      <p class="style-texto-chip" style="margin-bottom: 0">
        {{ tipoAtencion }}
      </p>
    </div>

    @if ([ TipoAtencion.DOMICILIARIA, TipoAtencion.PRESENCIAL ].includes( tipoAtencion )) {
    <div class="card-row">
      <img src="assets/icons/pin-info-consulta.svg" style="display: table-cell" alt="house" />
      <span class="texto-light" style="margin-left: 12px">
        {{ data.detalleAtencion }}
      </span>
    </div>
    }
  </div>
  <div class="card-footer">
    <div [sophHasAccess]="[AppPermissions.EDIT_APPOINTMENT]">
      @if (data.estado === EstadoFichaClinica.AGENDADA) {
      <button class="btn edit-btn texto-info" (click)="editarConsulta()">Editar consulta</button>
      }
    </div>
    <div [sophHasAccess]="[AppPermissions.SEE_IDENTIFICATION, AppPermissions.SEE_ANAMNESIS]">
      @if ( data.estado === EstadoFichaClinica.AGENDADA || data.estado ===
      EstadoFichaClinica.PROCESO ) {
      <button class="btn go-btn texto-info" (click)="irAFicha()">Ir a la consulta</button>
      }
    </div>
  </div>
  @switch ( data.estado ) { @case ( EstadoFichaClinica.REALIZADA ) {
  <div
    [sophHasAccess]="[AppPermissions.SEE_IDENTIFICATION, AppPermissions.SEE_ANAMNESIS]"
    class="card-footer"
    style="place-self: center"
  >
    <button class="btn go-btn texto-info" (click)="openResumenConsulta()">Ver consulta</button>
  </div>
  } @case ( EstadoFichaClinica.AGENDADA ) {
  <div class="section-anular" [sophHasAccess]="[AppPermissions.CANCEL_APPOINTMENT]">
    <img src="assets/icons/anular-info-consulta.svg" style="display: table-cell" alt="house" />
    <p class="text-anular-consulta" (click)="anularConsulta()">Anular consulta</p>
  </div>
  } }
</div>
